(function() {
  if (window.__logoutClearCartBound) return;
  window.__logoutClearCartBound = true;

  // Normaliza os alvos de logout (account/logout, customer_identity/logout, etc.)
  const logoutTargets = [
    '',
    '/customer_identity/logout',
    '/customer/logout'
  ]
    .filter(Boolean)
    .map((h) => h.toLowerCase());

  const isLogoutHref = (href) => {
    if (!href) return false;
    const h = href.toLowerCase();
    return h.includes('logout') || logoutTargets.includes(h);
  };

  // Captura cliques em qualquer link de logout e limpa o carrinho antes do redirect
  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a');
      if (!link) return;
      const href = link.getAttribute('href');
      if (!isLogoutHref(href)) return;

      event.preventDefault();
      fetch('/cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store'
      })
        .catch(() => {})
        .finally(() => {
          window.location.href = href;
        });
    },
    true // captura cedo para pegar popups/menus
  );
})();
